<template>
<form data-no-prevent="true">
	<template v-for="(step, index) in guideSteps">
		<guide-step v-bind="step" :index="index" :selectedOption="(index < guideSteps.length -1) ? guideSteps[index+1].id : ''" @fetchStep="fetchStep"></guide-step>
	</template>
</form>
</template>

<script>
import GuideStep from '@/components/step-by-step-guide/guide-step/GuideStep.vue';
export default {
    name: 'GuideSteps',
    props: {
        guideSteps: {
            type: Array,
            default: () => []
        },
    },
    components: {
		GuideStep
	},
    methods: {
		fetchStep(params) {
			this.$emit('fetchStep', params);
		}
    },
    created() {
    }
}
</script>
